<script>
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

// Custom Compoents
import Transaction from "@/components/BookingDetails/Transaction.vue";
import BookingService from "@/helpers/APIService/booking.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";

export default {
  components: {
    Multiselect,
    Transaction,
  },
  props: {
    currentProps: Object,
  },
  data() {
    return {
      folios: [],
      isDataLoading: true,
      guestList: [],
      isNewFolioBtnLoading: false,
      newFolio: {
        index: null,
        oldFolio: null,
        isEdit: false,
        guest: null,
        title: "Add Folio",
      },

      all_transactions: [],
      total_debit: parseFloat(0),
      total_credit: parseFloat(0),
      total: parseFloat(0),
      isMoveTransactionBtnLoading: false,
      moveTransaction: {
        folio: null,
        transaction: null,
      },
      runTransaction: true,
      is_reverse_transaction: false,
    };
  },
  computed: {
    ...authComputed,
    folioProps() {
      return {
        folios: this.folios,
        booking: this.currentProps.booking,
        is_reverse_transaction: this.is_reverse_transaction,
      };
    },
  },
  async mounted() {
    await this.setValues();
  },
  methods: {
    async setValues() {
      this.isDataLoading = true;
      await this.getFolios();
      await this.getGuestList();
      this.isDataLoading = false;
    },
    async getFolios() {
      await BookingService.getFolioList(this.currentProps.booking.id)
        .then((folios) => {
          this.folios = [];
          folios.map((folio) => {
            folio.name = `#${folio.folio_number} ${folio.guest.first_name} ${folio.guest.last_name}`;
            this.folios.push(folio);
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    closeNewFolioModal() {
      this.newFolio.guest = null;
      this.newFolio.oldFolio = null;
      this.newFolio.isEdit = false;
      this.newFolio.index = null;
      this.newFolio.title = "Add Folio";
    },
    addFolio() {
      this.isNewFolioBtnLoading = true;
      let folioData = new FormData();
      folioData.append("guest", this.newFolio.guest.id);
      if (this.newFolio.isEdit == false) {
        folioData.append("hotel", this.hotel.id);
        folioData.append("booking", this.currentProps.booking.id);

        BookingService.createFolio(this.currentProps.booking.id, folioData)
          .then((folio) => {
            Middleware.notification("Successfully added !!", "success", 3000);
            folio.name = "#" + folio.folio_number + " " + folio.guest.name;
            this.folios.push(folio);
            this.getGuestList();
            this.isNewFolioBtnLoading = false;
            this.$bvModal.hide("new-folio-modal");
          })
          .catch((error) => {
            this.isNewFolioBtnLoading = false;
            errorHandler(error);
          });
      } else {
        BookingService.editFolio(
          this.currentProps.booking.id,
          this.newFolio.oldFolio.id,
          folioData
        )
          .then((folio) => {
            Middleware.notification("Successfully updated !!", "success", 3000);
            folio.name = "#" + folio.folio_number;
            this.folios[this.newFolio.index] = folio;
            this.getGuestList();
            this.isNewFolioBtnLoading = false;
            this.$bvModal.hide("new-folio-modal");
          })
          .catch((error) => {
            this.isNewFolioBtnLoading = false;
            errorHandler(error);
          });
      }
    },
    getGuestList() {
      this.guestList = [];
      this.currentProps.booking.guest.map((guest) => {
        guest.name = guest.first_name + " " + guest.last_name;
        this.guestList.push(guest);
      });
    },
    editFolio(folio, index) {
      this.newFolio.oldFolio = folio;
      this.newFolio.isEdit = true;
      this.newFolio.index = index;
      this.newFolio.title = "Edit Folio";
      this.$bvModal.show("new-folio-modal");
    },
    deleteFolio(folio, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          BookingService.deleteFolio(this.currentProps.booking.id, folio.id)
            .then(async () => {
              await this.folios.splice(index, 1);
              this.showTransaction();
              Middleware.notification(
                "Successfully deleted !!",
                "success",
                3000
              );
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    findBalance(debit, credit) {
      let formatNo = 0.0;
      formatNo = parseFloat(debit) - parseFloat(credit);
      return formatNo.toFixed(2);
    },
    openMoveTransactionModal(data) {
      this.moveTransaction.transaction = data;
      this.$bvModal.show("add-transaction-folio-modal");
    },
    closeMoveTransactionModal() {
      this.isMoveTransactionBtnLoading = false;
      this.moveTransaction.transaction = null;
      this.moveTransaction.folio = null;
    },
    addTransaction() {
      this.isMoveTransactionBtnLoading = true;
      BookingService.transactionInFolio(
        this.moveTransaction.folio.id,
        this.moveTransaction.transaction.id,
        "add"
      )
        .then(() => {
          Middleware.notification("Successfully moved !!", "success", 3000);

          this.isMoveTransactionBtnLoading = false;
          this.$bvModal.hide("add-transaction-folio-modal");

          this.setValues();
        })
        .catch((error) => {
          this.is_transaction_btn_loading = false;
          errorHandler(error);
        });
    },
    async showTransaction() {
      this.runTransaction = false;
      await this.setValues();
      this.runTransaction = true;
    },
  },
};
</script>
<template>
  <div>
    <h4>
      <span class="d-inline-block d-sm-none">
        <i class="fas fa-home"></i>
      </span>
      <span class="d-none d-sm-inline-block">Folio Details</span>
    </h4>
    <!-- First with origin and balance -->
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center">
          <span class="me-3 text-secondary"
            >Charge: $ {{ this.currentProps.total_charges }}
          </span>
          <span class="me-3 text-secondary"
            >Payment: $ {{ this.currentProps.total_payment }}</span
          >
          <span class="me-3 text-secondary"
            >Balance : $ {{ this.currentProps.current_bal }}</span
          >
          <span class="me-3 text-secondary"
            >Deposit(I Hold):
            <strong class="text-danger">
              $ {{ this.currentProps.total_sd }}</strong
            ></span
          >
          <span
            class="float-right form-check form-switch text-secondary mb-0 me-3"
          >
            Display Reversal Charges
            <input
              class="form-check-input"
              type="checkbox"
              id="display_reversal_charges"
              v-model="is_reverse_transaction"
              @click="showTransaction"
          /></span>
          <b-button
            variant="primary"
            class="btn-sm"
            v-b-modal.new-folio-modal
            @click="getGuestList"
          >
            Add Folio
          </b-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <b-tabs
          justified
          nav-class="nav-tabs-custom"
          content-class="py-3 text-muted"
        >
          <b-tab v-for="(folio, index) in folios" :key="index">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block" @click="showTransaction">
                #{{
                  folio.is_deposit_folio
                    ? folio.folio_number + " - Security Deposit"
                    : folio.folio_number
                }}
              </span>
              <template>
                <i
                  class="fas fa-pencil-alt ms-2 float-end"
                  v-if="
                    folio.is_default == false && folio.is_deposit_folio == false
                  "
                  v-b-popover.hover="'Edit Folio'"
                  @click="editFolio(folio, index)"
                ></i>
                <i
                  class="mdi mdi-trash-can-alt float-end"
                  v-if="
                    folio.is_default == false && folio.is_deposit_folio == false
                  "
                  v-b-popover.hover="'Delete Folio'"
                  @click="deleteFolio(folio, index)"
                ></i>
              </template>
            </template>
            <b-card-text>
              <Transaction
                v-if="runTransaction"
                :currentProps="{ ...folioProps, folio }"
                @updateFolio="showTransaction"
              />
            </b-card-text>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <!-- Modal is for add new folio -->
    <b-modal
      id="new-folio-modal"
      centered
      :title="newFolio.title"
      @hidden="closeNewFolioModal"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <b-form-group class="mb-3" label="Folio" label-for="email-input">
              <template slot="label">
                Guest <span class="text-danger">*</span>
              </template>
              <multiselect
                v-model="newFolio.guest"
                :options="guestList"
                :show-labels="false"
                track-by="id"
                label="name"
                placeholder="Select Guest"
              ></multiselect>
            </b-form-group>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="row">
          <div class="col-12">
            <b-button
              variant="primary"
              @click="addFolio"
              :class="{
                disabled: isNewFolioBtnLoading || newFolio.guest == null,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isNewFolioBtnLoading"
              ></i>
              Save
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- Modal is for add new transaction in to folio -->
    <b-modal
      id="add-transaction-folio-modal"
      centered
      title="Add Transaction in Folio"
      @hidden="closeMoveTransactionModal"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <b-form-group class="mb-3" label="Folio" label-for="email-input">
              <template slot="label">
                Move to Selected Folio <span class="text-danger">*</span>
              </template>
              <multiselect
                v-model="moveTransaction.folio"
                :options="folios"
                :show-labels="false"
                track-by="id"
                label="name"
                placeholder="Select Folio"
              ></multiselect>
            </b-form-group>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="row">
          <div class="col-12">
            <b-button
              variant="primary"
              @click="addTransaction"
              :class="{
                disabled:
                  isMoveTransactionBtnLoading || moveTransaction.folio == null,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isMoveTransactionBtnLoading"
              ></i>
              Move
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
